import React, { Component } from 'react'
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux'
import * as actions from '../../actions'
import _ from 'lodash'
import ReactDataGrid from 'react-data-grid'
import 'bootstrap/dist/css/bootstrap.css'
import Typography from '@material-ui/core/Typography'

export class SpaceScreen extends Component {
  static propTypes = {
    // prop: PropTypes
  }
  constructor(props) {
    super(props)

    this._usersColumns = [
      {key: 'user_id', name: 'User ID', resizable: true},
      {key: 'full_name', name: 'Full name', resizable: true, sortable: true},
      {key: 'email', name: 'E-mail', resizable: true},
      {key: 'group_titles', name: 'Groups', resizable: true, sortable: true}
    ]

    this._passwordsColumns = [
      {key: 'user_id', name: 'User ID', resizable: true},
      {key: 'full_name', name: 'Full name', resizable: true, sortable: true},
      {key: 'email', name: 'E-mail', resizable: true},
      {key: 'password', name: 'Password', resizeable: true}
    ]

    this._groupColumns = [
      {key: 'group_id', name: 'Group ID', resizable: true},
      {key: 'title', name: 'Title', resizable: true},
      {key: 'member_count', name: 'Members', resizable: true},
      {key: 'description', name: 'Description', resizable: true},
    ]
    this.state = {
      params: props.match.params
    }

    this.props.getSpaceInfo(props.match.params.space_id)
    this.props.getSpaces()
  }

  handleUserGridSort = (sortColumn, sortDirection) => {
    const comparer = (a, b) => {
      if (sortDirection === 'ASC') {
        return (a[sortColumn] > b[sortColumn]) ? 1 : -1;
      } else if (sortDirection === 'DESC') {
        return (a[sortColumn] < b[sortColumn]) ? 1 : -1;
      }
    };

    const users = sortDirection === 'NONE' ? this.props.currentSpace.users.slice(0) : this.props.currentSpace.users.sort(comparer);

    this.setState({ users });
  }

  handlePasswordsGridSort = (sortColumn, sortDirection) => {
    const comparer = (a, b) => {
      if (sortDirection === 'ASC') {
        return (a[sortColumn] > b[sortColumn]) ? 1 : -1;
      } else if (sortDirection === 'DESC') {
        return (a[sortColumn] < b[sortColumn]) ? 1 : -1;
      }
    };

    const passwords = sortDirection === 'NONE' ? this.props.currentSpace.passwords.slice(0) : this.props.currentSpace.passwords.sort(comparer);

    this.setState({ passwords });
  }


  render() {
    const { space, currentSpace } = this.props
    const { users, passwords } = this.state
    
    return (space && currentSpace) ? (
      <div style={Styles.container}>
        <Typography variant='headline' style={Styles.headline}>
        {`${space.title} (${space.space_id})`}
        </Typography>
        <Typography variant='title' style={Styles.title}>
        Groups
        </Typography>
        <ReactDataGrid
          columns={this._groupColumns}
          rowGetter={(i)=>currentSpace.groups[i]}
          rowsCount={currentSpace.groups.length}
          minHeight={200} />
        <Typography variant='title' style={Styles.title}>
        Users
        </Typography>
        
        <ReactDataGrid
          columns={this._usersColumns}
          onGridSort={this.handleUserGridSort}
          rowGetter={(i)=>users ? users[i] : currentSpace.users[i]}
          rowsCount={currentSpace.users.length}
          minHeight={500} />
        <Typography variant='title' style={Styles.title}>
        Passwords
        </Typography>
        
        <ReactDataGrid
          columns={this._passwordsColumns}
          onGridSort={this.handlePasswordsGridSort}
          rowGetter={(i)=>passwords ? passwords[i] : currentSpace.passwords[i]}
          rowsCount={currentSpace.passwords.length}
          minHeight={500} />
      </div>
    ) : null
  }
}

const mapStateToProps = (state, ownProps) => {
  const space_id = ownProps.match.params.space_id
  const {spaces} = state
  let space = null
  let currentSpace = null
  if(spaces && spaces.allSpaces) {
    space = _.find(spaces.allSpaces, {space_id})
  }

  if(spaces && spaces.currentSpace) {
    currentSpace = spaces.currentSpace
  }

  return {
    ...ownProps,
    space,
    currentSpace
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(actions, dispatch)
}

const Styles = {
  container: {
    margin: 30,
    marginTop: 100
  },
  headline: {
    marginBottom: 10,
  },
  title: {
    marginTop: 8,
    marginBottom: 8,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SpaceScreen)



// WEBPACK FOOTER //
// ./src/components/spaces/SpaceScreen.js